/* eslint-disable */
// Import tiny dependency directly from https://github.com/lukeed/sockette/blob/v2.0.6/src/index.js
// We were burned by a patch version update from 2.0.5 -> 2.0.6 and the library hasn't been updated for a long time anyway.

function noop() {}

export type SocketteOptions = {
  maxAttempts?: number;
  protocols?: string[];
  onmessage?: (ev: MessageEvent<any>) => any;
  onopen?: (ev: Event) => any;
  onerror?: (ev: Event) => any;
  onclose?: (ev: CloseEvent) => any;
  onreconnect?: (ev: CloseEvent | Event) => any;
  onmaximum?: (ev: CloseEvent | Event) => any;
  timeout?: number;
};

export class Sockette {
  private ws: WebSocket;
  private num = 0;
  private timer: ReturnType<typeof setTimeout>;
  private max: number;
  private messageQueue: any[] = []; // Queue for messages when not connected

  constructor(private url: string, private opts: SocketteOptions = {}) {
    this.max = opts.maxAttempts || Infinity;

    this.open();
  }

  public open() {
    this.ws = new WebSocket(this.url, this.opts.protocols || []);

    this.ws.onmessage = this.opts.onmessage || noop;

    this.ws.onopen = (e) => {
      (this.opts.onopen || noop)(e);
      this.num = 0;
      this.processQueuedMessages(); // Process any queued messages
    };

    this.ws.onclose = (e) => {
      e.code === 1e3 || e.code === 1001 || e.code === 1005 || this.reconnect(e);
      (this.opts.onclose || noop)(e);
    };

    this.ws.onerror = (e) => {
      e && e['code'] === 'ECONNREFUSED'
        ? this.reconnect(e)
        : (this.opts.onerror || noop)(e);
    };
  }

  public json(value: any) {
    if (this.isReady) {
      this.ws.send(JSON.stringify(value));
    } else {
      // Queue the message to be sent when connection is ready
      this.messageQueue.push(value);
      console.warn(
        'WebSocket is not in OPEN state, message queued. Current state:',
        this.readyState
      );
    }
  }

  public send(value: any) {
    if (this.isReady) {
      this.ws.send(value);
    } else {
      console.warn(
        'WebSocket is not in OPEN state, cannot send data. Current state:',
        this.readyState
      );
    }
  }

  public close(code?: number, reason?: string) {
    clearTimeout(this.timer);
    this.timer = null;
    this.ws.close(code || 1e3, reason);
  }

  public reconnect(e?: CloseEvent | Event) {
    if (this.num++ < this.max) {
      this.timer = setTimeout(() => {
        (this.opts.onreconnect || noop)(e);
        this.open();
      }, this.opts.timeout || 1e3);
    } else {
      (this.opts.onmaximum || noop)(e);
    }
  }

  private processQueuedMessages() {
    while (this.messageQueue.length > 0 && this.isReady) {
      const message = this.messageQueue.shift();
      this.ws.send(JSON.stringify(message));
    }
  }

  public get readyState(): number {
    return this.ws ? this.ws.readyState : WebSocket.CLOSED;
  }

  public get isReady(): boolean {
    return this.ws && this.ws.readyState === WebSocket.OPEN;
  }
}
